import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import { CreateProductTitleBar } from "../../../../configs/products";
import CancelModal from "../../../../shared/components/CancelModal";
import { WarningProductModal } from "../../../../configs/warningProductModal";

interface TitleProps {
    setValidated: Function;
    title: string;
    isOwnProfile: boolean;
    handleSubmit: Function;
    handleUpdatePassword: Function;
    isManager: boolean;
    onDataChange?: () => void;
    hasUnsavedChanges?: boolean;
    onCancelClick?: () => void;
    isSavingInfo?: boolean;
    isSavingPassword?: boolean;
}

const Title = ({
    setValidated,
    title,
    isOwnProfile,
    handleSubmit,
    handleUpdatePassword,
    isManager,
    onDataChange,
    hasUnsavedChanges,
    onCancelClick,
    isSavingInfo = false,
    isSavingPassword = false,
}: TitleProps) => {
    const navigate = useNavigate();
    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
    const activeTab: string = window.location.search;

    const tabName = useMemo(() => {
        const match = activeTab.match(/tab=([^&]+)/);
        return match ? match[1] : "";
    }, [activeTab]);

    const handleCancel = () => {
        if (onDataChange) {
            onDataChange();
        }

        if (onCancelClick && hasUnsavedChanges) {
            onCancelClick();
        } else {
            setIsOpenCancelModal(true);
        }
    };

    const titleActions = [
        isOwnProfile
            ? {
                  title: CreateProductTitleBar.cancelButton,
                  onClick: () => handleCancel(),
              }
            : null,
        tabName === "change-password" && isOwnProfile
            ? {
                  title: "Cập nhật mật khẩu",
                  variant: "contained",
                  isLoading: isSavingPassword,
                  onClick: () => {
                      if (isSavingPassword) return;
                      setValidated(false);
                      handleUpdatePassword();
                  },
              }
            : isOwnProfile || (!isOwnProfile && isManager)
              ? {
                    title: "Lưu thông tin",
                    variant: "contained",
                    isLoading: isSavingInfo,
                    onClick: () => {
                        if (isSavingInfo) return;
                        setValidated(true);
                        handleSubmit();
                    },
                }
              : null,
    ].filter(Boolean) as Array<TitleAction>;

    return (
        <>
            <TitleRow title={"Thông tin tài khoản của " + title} actions={titleActions} />
            {isOpenCancelModal && (
                <CancelModal
                    open={isOpenCancelModal}
                    title={WarningProductModal.title}
                    contentText={WarningProductModal.context}
                    handleConfirm={() => navigate("/dashboard/")}
                    handleClose={() => setIsOpenCancelModal(false)}
                />
            )}
        </>
    );
};

export default Title;
